import { useRef, useEffect } from 'react';

const useDebouncedFunc = (func, delay, cleanUp = false) => {
  const timeoutRef = useRef();

  const clearTimer = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = undefined;
    }
  };

  useEffect(() => (cleanUp ? clearTimer : undefined), [cleanUp]);

  return (...args) => {
    clearTimer();
    timeoutRef.current = setTimeout(() => func(...args), delay);
  };
};

export default useDebouncedFunc;
